module.exports = __webpack_public_path__ + "static/media/works-tsai.e087ba4b.jpg";